export interface GetOperatorOnlineDriversRequest {
  XpressOperatorId: number | string;
}

export class GetOperatorOnlineDriversResponse {
  Drivers: DriverInformation[] = [];
}

export interface DriverInformation {
  DriverId: number;
  FirstName: string;
  LastName: string;
  PhoneNumber: string;
  ImageUrl: string;
  PlateNumber?: string;
  Lat?: number;
  Long?: number;
  DriverActivityStatus: DriverActivityStatus;
  GoogleTripId?: string | null;
}

export enum DriverActivityStatus {
  OnTrip = 0,
  Idle = 1,
}
